export const KATEX_RENDER_OPTIONS = {
  throwOnError: false,
  strict: 'ignore' as const,
};
